import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FileBase64 from "react-file-base64";
import imageToBase64 from "image-to-base64/browser";
import {
  Button,
  Grid,
  Typography,
  withWidth,
  makeStyles,
  Paper,
  Divider,
} from "@material-ui/core";
import {
  Container,
  DataGrid,
  Paginate,
  InputText,
  Loading,
  HeaderCard,
} from "src/components";
import {
  Save as SaveIcon,
  ArrowBack as VoltarIcon,
  Add as AddIcon,
  CloudUpload as UploadIcon,
  Equalizer as DashBoardIcon,
  SupervisedUserCircle as ClientesIcon,
  AutoAwesomeMotion as ModulosIcon,
  Bookmarks as CategoriaIcon,
  BusinessCenter as EditarIcon,
} from "@material-ui/icons";

import NumberFormat from "react-number-format";
import { useNavigate } from "react-router-dom";

import * as types from "src/store/types/configuracoes";
import {
  carregarConfiguracoes,
  salvarEmpresa,
  salvarConfiguracoes,
  uploadLogoEmpresa,
  carregarEmpresa,
} from "src/store/actions/configuracoes";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    position: "absolute",
    top: "10px",
    right: "0px",
    zindex: 100,
    width: 100,
    height: 45,
    fontSize: 14,
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.255)",
    background: "#ffffff",
  },
}));

function Configuracoes({ width }) {
  const classes = useStyles();
  const [image, setImage] = useState("");

  const dispatch = useDispatch();
  const { loading, configuracoes } = useSelector(
    (state) => state.configuracoes
  );
  const { empresa_atual } = useSelector((state) => state.usuario);

  useEffect(() => {
    dispatch([carregarConfiguracoes()]);

    imageToBase64(
      `https://images-conexo.us-east-1.linodeobjects.com/logos/${
        empresa_atual.id
      }.png?data=${new Date().getTime()}`
    )
      .then((image) => setImage(`data:image/png;base64, ${image}`))
      .catch((error) => console.log(error));
  }, [dispatch, empresa_atual.id]);

  const changedConfiguracoes = (data) => {
    dispatch({
      type: types.CONF_SET_CONFIGURACOES,
      payload: { ...configuracoes, ...data },
    });
  };

  async function salvaEmpresa() {
    await salvarEmpresa({ loading: true });
    dispatch(carregarConfiguracoes());
  }

  async function salvaConfiguracao() {
    await salvarConfiguracoes({ loading: true });
    dispatch(carregarConfiguracoes());
  }

  function getFiles(files) {
    setImage(files.base64);
  }

  async function uploadLogo() {
    await uploadLogoEmpresa(image);
  }

  return (
    <Container
      title={`${configuracoes.id > 0 ? "Editar" : "Nova"} configuracoes | ${
        configuracoes.nome
      } `}
    >
      <Loading loading={loading} />
      <Grid container spacing={2}>
        <Grid container item sm={6}>
          <Paper
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <HeaderCard
              title="Dados de Cadastro"
              subtitle="Informações de cadastro da configuracoes."
              iconSave={() => <SaveIcon />}
              onSave={() => salvaEmpresa()}
            />
            <Divider />
            <Grid container spacing={1}>
              <Grid item sm={2}>
                <InputText disabled label="ID" value={configuracoes.id} />
              </Grid>
              <Grid item sm={6}>
                <InputText
                  label="Razão Social"
                  required={true}
                  value={configuracoes.nome}
                  onChange={(event) =>
                    changedConfiguracoes({ nome: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <InputText
                  label="CNPJ"
                  required={true}
                  value={configuracoes.cpf_cnpj}
                  onChange={(event) =>
                    changedConfiguracoes({ cpf_cnpj: event.target.value })
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item sm={3}>
                <InputText
                  label="CEP"
                  required={true}
                  value={configuracoes.cep}
                  onChange={(event) =>
                    changedConfiguracoes({ cep: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={5}>
                <InputText
                  label="Logradouro"
                  required={true}
                  value={configuracoes.endereco}
                  onChange={(event) =>
                    changedConfiguracoes({ endereco: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={1}>
                <InputText
                  label="Nro."
                  value={configuracoes.numero}
                  onChange={(event) =>
                    changedConfiguracoes({ numero: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={3}>
                <InputText
                  label="Complemento"
                  value={configuracoes.complemento}
                  onChange={(event) =>
                    changedConfiguracoes({ complemento: event.target.value })
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item sm={5}>
                <InputText
                  label="Bairro"
                  value={configuracoes.bairro}
                  onChange={(event) =>
                    changedConfiguracoes({ bairro: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={5}>
                <InputText
                  label="Cidade"
                  value={configuracoes.cidade}
                  onChange={(event) =>
                    changedConfiguracoes({ cidade: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={2}>
                <InputText
                  label="UF"
                  value={configuracoes.uf}
                  onChange={(event) =>
                    changedConfiguracoes({ uf: event.target.value })
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item sm={3}>
                <InputText
                  label="Telefone"
                  value={configuracoes.telefone}
                  onChange={(event) =>
                    changedConfiguracoes({ telefone: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={3}>
                <InputText
                  label="Cel.WhatsApp"
                  value={configuracoes.celular}
                  onChange={(event) =>
                    changedConfiguracoes({ celular: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={6}>
                <InputText
                  label="Email"
                  value={configuracoes.email}
                  onChange={(event) =>
                    changedConfiguracoes({ email: event.target.value })
                  }
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid container direction="column" item sm={6}>
          <Paper
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <HeaderCard
              title="Dados de Configuração"
              subtitle="Informações de configuração plataforma."
              iconSave={() => <SaveIcon />}
              onSave={() => salvaConfiguracao()}
              disabledSave={configuracoes.id > 0 ? false : true}
            />
            <Divider />
            <Grid container spacing={1}>
              <Grid item sm={4}>
                <InputText
                  disabled={configuracoes.id > 0 ? false : true}
                  label="Nome Fantasia"
                  value={configuracoes.nome_fantasia}
                  onChange={(event) =>
                    changedConfiguracoes({ nome_fantasia: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={2}>
                <InputText
                  disabled={configuracoes.id > 0 ? false : true}
                  label="Qtde. Alerta"
                  value={configuracoes.qtd_maximo}
                  onChange={(event) =>
                    changedConfiguracoes({ qtd_maximo: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={2}>
                <InputText
                  disabled={configuracoes.id > 0 ? false : true}
                  label="Valor Alerta"
                  value={configuracoes.valor_maximo}
                  onChange={(event) =>
                    changedConfiguracoes({ valor_maximo: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={2}>
                <InputText
                  disabled={configuracoes.id > 0 ? (empresa_atual.tipo_cashback == 'F' ? true : false) : true}
                  label="% Cashback"
                  value={configuracoes.cashback}
                  onChange={(event) =>
                    changedConfiguracoes({ cashback: event.target.value })
                  }
                />
              </Grid>
              <Grid item sm={2}>
                <InputText
                  disabled={configuracoes.id > 0 ? false : true}
                  label="Validade"
                  value={configuracoes.dias_vencto_cashback}
                  onChange={(event) =>
                    changedConfiguracoes({
                      dias_vencto_cashback: event.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item sm={12}>
                <InputText
                  disabled={configuracoes.id > 0 ? false : true}
                  label="Descrição da Empresa."
                  value={configuracoes.descricao_empresa}
                  multiline
                  rows={3}
                  onChange={(event) =>
                    changedConfiguracoes({
                      descricao_empresa: event.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item sm={12}>
                <InputText
                  disabled={configuracoes.id > 0 ? false : true}
                  label="Horário de Funcionamento"
                  value={configuracoes.horario_funcionamento}
                  onChange={(event) =>
                    changedConfiguracoes({
                      horario_funcionamento: event.target.value,
                    })
                  }
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid container item sm={3}>
          <Paper
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              paddingLeft: 10,
              paddingRight: 10,
              alignItems: "center",
            }}
          >
            <HeaderCard
              title="Logomarca"
              subtitle="Irá aparecer no App."
              iconSave={() => <UploadIcon />}
              onSave={() => uploadLogo()}
              onTitle="Upload"
              disabledSave={configuracoes.id > 0 ? false : true}
            />
            <Divider style={{ width: "100%", marginBottom: 5 }} />
            {configuracoes.id > 0 && (
              <FileBase64 multiple={false} onDone={getFiles} />
            )}

            <img
              alt=""
              src={image}
              style={{ margin: 5, width: 180, height: 180, borderRadius: 10 }}
            />
          </Paper>
        </Grid>
        <Grid container item sm={3}>
          <Paper
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              paddingLeft: 10,
              paddingRight: 10,
              alignItems: "center",
            }}
          >
            <HeaderCard title="Resumo" subtitle="Resumo na Plataforma." />
            <Divider style={{ width: "100%", marginBottom: 5 }} />
            <InputText
              disabled={true}
              label="Qtde de Clientes"
              value={configuracoes.clientes}
            />
            <NumberFormat
              decimalScale={2}
              fixedDecimalScale={true}
              defaultValue={0}
              prefix={"R$ "}
              thousandSeparator={"."}
              decimalSeparator={","}
              customInput={InputText}
              disabled={true}
              label="R$ CashBack Ativo"
              value={configuracoes.cashback_ativo}
            />
            <InputText
              disabled={true}
              label="Qtde Cashback em 30 dias."
              value={configuracoes.cashbacks_mes}
            />
          </Paper>
        </Grid>
        <Grid container item sm={3}>
          <Paper
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              paddingLeft: 10,
              paddingRight: 10,
              alignItems: "center",
            }}
          >
            <HeaderCard
            // title="Resumo"
            // subtitle="Resumo na Plataforma."
            />
            <Divider style={{ width: "100%", marginBottom: 5 }} />
          </Paper>
        </Grid>
        <Grid container item sm={3}>
          <Paper
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              paddingLeft: 10,
              paddingRight: 10,
              alignItems: "center",
            }}
          >
            <HeaderCard
            // title="Resumo"
            // subtitle="Resumo na Plataforma."
            />
            <Divider style={{ width: "100%", marginBottom: 5 }} />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default withWidth()(Configuracoes);
